import { StyledButton } from './ButtonCta.styles';

function ButtonCta(props) {
  return <StyledButton {...props} />;
}

export default ButtonCta;
